import { rafTimer } from '@utils/RafTimer'

/**
 * 极简轮询 Hook
 * @param callback 业务函数
 * @param interval 间隔(ms)
 * @param immediate 是否立即执行
 */
export function useRafPolling(
  callback: () => Promise<void> | void,
  interval: number,
  immediate = false,
) {
  // 生成唯一 Key
  const key = Symbol('RafTask')

  // 启动轮询
  const start = () => {
    rafTimer.addTask(
      {
        key,
        interval,
        callback,
        immediate,
      },
      true,
    ) // true = 开启自动销毁
  }

  // 手动停止
  const stop = () => {
    rafTimer.removeTask(key)
  }

  return { start, stop }
}
